import { Link } from 'react-router-dom';
import Reveal from '@/components/feature/Reveal';

export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-transparent to-accent-500/10"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-primary-500/10 blur-[140px]"></div>
      </div>

      <div className="relative mx-auto max-w-4xl px-4 md:px-6 text-center">
        <Reveal>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 leading-tight tracking-tight">
            ¿Tienes una idea, un proceso manual o sistemas que no conversan?
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-500">
            Cuéntanos qué quieres resolver. Nosotros vemos cómo convertirlo en
            tecnología.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/contacto"
              className="w-full sm:w-auto text-center whitespace-nowrap font-medium text-background-950 bg-primary-500 hover:bg-primary-600 rounded-md px-8 py-4 transition-colors cursor-pointer glow-primary"
            >
              Hablemos de tu proyecto
            </Link>
            <Link
              to="/contacto"
              className="w-full sm:w-auto text-center whitespace-nowrap font-medium text-foreground-900 border border-background-700 hover:border-foreground-500 hover:bg-background-800 rounded-md px-8 py-4 transition-colors cursor-pointer"
            >
              Contactar ACOMA
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}